var parent = require('../../es/instance/concat');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/stable/instance/concat.js
// module id = 1109
// module chunks = 0